module.exports = __webpack_public_path__ + "static/media/AXIS.fa1b575f.svg";